import gql from 'graphql-tag';

export const RESET_OTP_LIMIT = gql`
  mutation ResetOtpLimit($userId: String!) {
    resetOtpLimit(userId: $userId) {
      success
    }
  }
`;
